import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LocalStorageService } from '../shared/services/local-storage.service';
import { AccountService } from '../auth/services/account.service';
import { RefreshTokenService } from './refresh-token.service';

export const refreshTokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const accountService = inject(AccountService);
  const token = inject(LocalStorageService).token;
  const refreshTokenService = inject(RefreshTokenService);
  return next(req).pipe(
    catchError((error) => {
      const isRefreshTokenExpired = accountService.isExpired(token?.refreshTokenExpires);
      const isTokenExpired = accountService.isExpired(token?.expiration);
      if (error instanceof HttpErrorResponse && error.status === 401 && !isRefreshTokenExpired && isTokenExpired) {
        return refreshTokenService.handleExpiredTokenError(req, next);
      } else {
        throw error;
      }
    }),
  );
};
